import { FunctionComponent } from 'react';
import styles from './ColorManager.module.scss';
import clsx from 'clsx';

interface ColorComponentProps {
    color: string;
    selected?: boolean;
    onSelect: () => void;
}

export const ColorComponent: FunctionComponent<ColorComponentProps> = ({ color, selected, onSelect }) => {
    return (
        <div
            className={clsx(styles.colorCircle, {
                [styles.selected]: selected,
                [styles.transparent]: color === 'inherit'
            })}
            onClick={onSelect}
        >
            <div
                className={styles.colorInner}
                style={{ backgroundColor: color === 'inherit' ? 'transparent' : color }}
            >
                {color === 'inherit' && (
                    <svg
                        width={32}
                        height={32}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            pointerEvents: 'none'
                        }}
                    >
                        <line
                            x1="4"
                            y1="28"
                            x2="28"
                            y2="4"
                            stroke="#F05B5B"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                        />
                    </svg>
                )}
            </div>
        </div>
    );
};

export default ColorComponent;
